import React, { useState, useEffect } from "react";
import "./TerminalTyping.css";

const TerminalTyping = ({ commands }) => {
  const [lines, setLines] = useState([]);
  const [currentCommandIndex, setCurrentCommandIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");

  useEffect(() => {
    if (currentCommandIndex >= commands.length) {
      return;
    }

    const currentEntry = commands[currentCommandIndex];
    const isCommand = currentCommandIndex % 2 === 0;

    if (isCommand) {
      // Typing a command
      if (currentText.length < currentEntry.length) {
        const timeout = setTimeout(() => {
          setCurrentText(currentEntry.slice(0, currentText.length + 1));
        }, 50);
        return () => clearTimeout(timeout);
      } else {
        // Command finished typing, add to lines and move to output
        setLines((prev) => [...prev, { text: currentEntry, isCommand: true }]);
        setCurrentText("");
        setCurrentCommandIndex(currentCommandIndex + 1);
      }
    } else {
      // Displaying output
      const timeout = setTimeout(() => {
        setLines((prev) => [...prev, { text: currentEntry, isCommand: false }]);
        setCurrentCommandIndex(currentCommandIndex + 1);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [currentCommandIndex, currentText, commands]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      // Your cursor logic here if needed
    }, 500);
    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <div className="terminal-typing-container">
      {lines.map((line, index) => (
        <div
          key={index}
          className={line.isCommand ? "terminal-line" : "output"}
        >
          {line.isCommand && <span className="prompt">user@parrot:~$ </span>}
          {line.isCommand ? (
            <span className="command">{line.text}</span>
          ) : (
            <pre className="output-text">{line.text}</pre>
          )}
        </div>
      ))}
      {currentCommandIndex % 2 === 0 &&
        currentCommandIndex < commands.length && (
          <div className="terminal-line">
            <span className="prompt">user@parrot:~$ </span>
            <span className="command">{currentText}</span>
            <span className="cursor"></span>
          </div>
        )}
      {currentCommandIndex >= commands.length && (
        <div className="terminal-line">
          <span className="prompt">user@parrot:~$ </span>
          <span className="cursor"></span>
        </div>
      )}
    </div>
  );
};

export default TerminalTyping;
